<ndt-edit-mailbox-pin-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-edit-mailbox-pin-view>
